import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { MoreHorizontal } from "lucide-react";

type ActionItem = {
  key: string;
  label: string | React.ReactNode;
  danger?: boolean;
};

interface ActionMenuProps {
  items: ActionItem[];
  onSelect: (key: string) => void;
}

export default function ActionMenu({ items, onSelect }: ActionMenuProps) {
  const menuItems = items.map((it) => ({ key: it.key, label: it.label, danger: it.danger }));

  return (
    <Dropdown overlay={<Menu onClick={({ key }) => onSelect(String(key))} items={menuItems} />} trigger={["click"]}>
      <Button type="text" icon={<MoreHorizontal />} />
    </Dropdown>
  );
}
